import { css as v, LitElement as h, html as s, nothing as c } from "lit";
import { property as l, customElement as u } from "lit/decorators.js";
import { classMap as g } from "lit/directives/class-map.js";
import { b } from "./styles-scZ6dVz-.js";
var f = Object.defineProperty, m = Object.getOwnPropertyDescriptor, a = (n, r, o, i) => {
  for (var t = i > 1 ? void 0 : i ? m(r, o) : r, d = n.length - 1, p; d >= 0; d--)
    (p = n[d]) && (t = (i ? p(r, o, t) : p(t)) || t);
  return i && t && f(r, o, t), t;
};
let e = class extends h {
  constructor() {
    super(...arguments), this.panelTitle = "", this.subtitle = "", this.collapsible = !1, this.collapsed = !1, this.variant = "default", this.chevronIcon = s`
    <svg
      class="chevron"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m6 9 6 6 6-6"/>
    </svg>
  `;
  }
  handleToggle() {
    this.collapsible && (this.collapsed = !this.collapsed, this.dispatchEvent(
      new CustomEvent("ark-toggle", {
        detail: { collapsed: this.collapsed },
        bubbles: !0,
        composed: !0
      })
    ));
  }
  render() {
    const n = {
      panel: !0,
      collapsed: this.collapsed,
      [this.variant]: !0,
      "not-collapsible": !this.collapsible
    }, r = "panel-content", o = "panel-header";
    return s`
      <div part="panel" class=${g(n)}>
        <div part="header" class="header" id=${o}>
          ${this.collapsible ? s`
                <button
                  part="toggle"
                  class="toggle"
                  type="button"
                  aria-expanded=${!this.collapsed}
                  aria-controls=${r}
                  @click=${this.handleToggle}
                >
                  <span part="chevron">${this.chevronIcon}</span>
                </button>
              ` : c}

          <div class="title-wrapper">
            <slot name="header">
              ${this.panelTitle ? s`<h3 part="title" class="title">${this.panelTitle}</h3>` : c}
              ${this.subtitle ? s`<div class="subtitle">${this.subtitle}</div>` : c}
            </slot>
          </div>

          <div part="actions" class="actions">
            <slot name="header-actions"></slot>
          </div>
        </div>

        <div
          class="content-wrapper"
          id=${r}
          role="region"
          aria-labelledby=${o}
          aria-hidden=${this.collapsed}
        >
          <div part="content" class="content">
            <div class="content-inner">
              <slot></slot>
            </div>
          </div>
        </div>

        <div part="footer" class="footer">
          <slot name="footer"></slot>
        </div>
      </div>
    `;
  }
};
e.styles = [
  b,
  v`
      :host {
        display: block;
      }

      .panel {
        background-color: var(--r5-surface);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-lg);
        overflow: hidden;
      }

      /* Header */
      .header {
        display: flex;
        align-items: center;
        gap: var(--r5-space-3);
        padding: var(--r5-space-4) var(--r5-space-5);
        background-color: var(--r5-bg-muted);
        border-bottom: 1px solid var(--r5-border);
      }

      .collapsed .header {
        border-bottom-color: transparent;
      }

      .toggle {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.5rem;
        height: 1.5rem;
        padding: 0;
        border: none;
        background: transparent;
        color: var(--r5-text-muted);
        cursor: pointer;
        border-radius: var(--r5-radius-sm);
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .toggle:hover {
        background-color: var(--r5-surface);
        color: var(--r5-text);
      }

      .toggle:focus-visible {
        outline: var(--r5-focus-ring-width) solid var(--r5-focus-ring-color);
        outline-offset: var(--r5-focus-ring-offset);
      }

      .chevron {
        width: 1rem;
        height: 1rem;
        transition: transform var(--r5-duration-normal) var(--r5-ease-out);
      }

      .collapsed .chevron {
        transform: rotate(-90deg);
      }

      .title-wrapper {
        flex: 1;
        min-width: 0;
      }

      .title {
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-semibold);
        color: var(--r5-text);
        margin: 0;
        line-height: var(--r5-leading-tight);
      }

      .subtitle {
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
        margin-top: var(--r5-space-0-5);
      }

      .actions {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        flex-shrink: 0;
      }

      /* Non-collapsible header */
      .not-collapsible .header {
        padding-left: var(--r5-space-5);
      }

      /* Content */
      .content-wrapper {
        display: grid;
        grid-template-rows: 1fr;
        transition: grid-template-rows var(--r5-duration-normal) var(--r5-ease-out);
      }

      .collapsed .content-wrapper {
        grid-template-rows: 0fr;
      }

      .content {
        overflow: hidden;
      }

      .content-inner {
        padding: var(--r5-space-5);
      }

      /* Footer */
      .footer {
        padding: var(--r5-space-4) var(--r5-space-5);
        border-top: 1px solid var(--r5-border);
        background-color: var(--r5-bg-muted);
      }

      .footer:empty {
        display: none;
      }

      /* Variants */
      .borderless {
        border: none;
        border-radius: 0;
      }

      .borderless .header {
        background-color: transparent;
        border-bottom: 1px solid var(--r5-border);
      }

      .borderless .footer {
        background-color: transparent;
      }

      /* Flush variant - no padding */
      .flush .content-inner {
        padding: 0;
      }

      @media (prefers-reduced-motion: reduce) {
        .chevron,
        .content-wrapper {
          transition: none;
        }
      }
    `
];
a([
  l({ type: String })
], e.prototype, "panelTitle", 2);
a([
  l({ type: String })
], e.prototype, "subtitle", 2);
a([
  l({ type: Boolean, reflect: !0 })
], e.prototype, "collapsible", 2);
a([
  l({ type: Boolean, reflect: !0 })
], e.prototype, "collapsed", 2);
a([
  l({ type: String, reflect: !0 })
], e.prototype, "variant", 2);
e = a([
  u("ark-panel")
], e);
export {
  e as A
};
//# sourceMappingURL=ark-panel-BvVltua7.js.map
